import { render } from "./FormCreateSubcourse.vue?vue&type=template&id=0f00dd48&scoped=true"
import script from "./FormCreateSubcourse.vue?vue&type=script&lang=js"
export * from "./FormCreateSubcourse.vue?vue&type=script&lang=js"

import "./FormCreateSubcourse.vue?vue&type=style&index=0&id=0f00dd48&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f00dd48"]])

export default __exports__